export {CustomerInsightsTrigger} from './components/CustomerInsightsTrigger/CustomerInsightsTrigger';
export type {CustomerInsightsTriggerProps} from './components/CustomerInsightsTrigger/CustomerInsightsTrigger';
